import React from "react"
import OrderReceiptTemplate1 from "./receipt-template/order-receipt-template-1"
import { BoxProps } from "@mui/material"
import { ReceiptTemplateType } from "src/graphql/quark/quark.type"
import OrderReceiptTemplate2 from "./receipt-template/order-receipt-template-2"

export const DEFAULT_ORDER_RECEIPT_TITLE = "Sales Tax Invoice"

export interface OrderReceiptItemDataProps {
  name?: string
  quantity?: number
  unitPrice?: number
  discount?: number
  taxRate?: number
  taxExclusive?: number
  taxAmount?: number
  total?: number
  beforeDiscount?: number
  skuCode?: string
}

export interface OrderReceiptDataProps {
  logo?: string
  title?: string
  orderNumber?: string
  companyName?: string
  websiteUrl?: string
  locationName?: string
  locationAddress?: string
  orderDate?: string
  orderType?: string
  commercialId?: string
  registerName?: string
  cashierName?: string
  customerName?: string
  customerPhone?: string
  customerEmail?: string
  customerAddress?: string
  customerTaxNo?: string
  customerCommercialNo?: string
  items?: OrderReceiptItemDataProps[]
  subtotal?: number
  totalDiscount?: number
  productDiscount?: number
  orderDiscount?: number
  cardDiscount?: number
  tax?: number
  shippingFee?: number
  platformFee?: number
  orderPlatformFees?: { name?: string; amount?: number }[] | []
  posFee?: number
  integrationFee?: number
  total?: number
  paymentMethod?: string
  transactionNumber?: string
  specialInstructions?: string
  mrNo?: string
  integrationPartnerInvoice?: string
  isDuplicateSlip?: boolean
  fbrInvoiceId?: string | null
  showOrderNumberQr?: boolean
  integrations?: { name?: string | null; charges?: number }[] | []
  createdAt?: string
}

export interface OrderReceiptBaseProps extends BoxProps {
  receiptData: OrderReceiptDataProps
  receiptRef?: React.RefObject<HTMLDivElement>
  isHideFooter?: boolean
}
interface OrderReceiptProps extends OrderReceiptBaseProps {
  receiptType: ReceiptTemplateType
}

const OrderReceipt: React.FC<OrderReceiptProps> = ({ receiptType, ...rest }) => {
  if (receiptType === ReceiptTemplateType.Template_1) return <OrderReceiptTemplate1 {...rest} />
  if (receiptType === ReceiptTemplateType.Template_2) return <OrderReceiptTemplate2 {...rest} />
}

export default OrderReceipt
